import { z } from 'zod';

export const ChatCreateSchema = z.object({
  recordingId: z.string().optional(),
});

export type ChatCreate = z.infer<typeof ChatCreateSchema>;
